<p-multiSelect
    [options]="listOfOptions"
    [(ngModel)]="selectedOptions"
    optionLabel="id"
    [filter]="false"
    [styleClass]="'rounded-lg multiselect-input'"
    (ngModelChange)="onChange($event)"
></p-multiSelect>
